import { useTranslation } from '@testsigma/atoms';

interface UploadModalHeaderProps {
  isCreateNew: boolean;
}

export const UploadModalHeaderPanel: React.FC<UploadModalHeaderProps> = ({
  isCreateNew,
}) => {
  const { t } = useTranslation();

  return (
    <div className='flex items-center w-full'>
      {isCreateNew ? (
        <div className='font-medium text-lg text-unique-600'>
          {t('upload.upload_a_file.label')}
        </div>
      ) : (
        <div className='font-medium text-lg text-unique-600'>
          {t('upload.new.version')}
        </div>
      )}
    </div>
  );
};
